import { axios } from '@/lib/axios';

export const checkUsername = (username: string): Promise<{ available: boolean }> => {
  return axios.get('/check-username', { params: { username } });
};
